<template>
  <div class="pa-2">
    <div class="ml-2 mb-6" style="display: grid; align-items: center;">
      <p class="green--text accent-3--text text-sm ma-0 caption">
        REPLAY
      </p>
      <h1 class="white--text font-weight-light">
        Reporte de usuarios
      </h1>
    </div>
    <div class="ma-2">
      <p class="white--text subtitle-2">
        Filtrar por:
      </p>
      <div
        class="flex justify-between my-4"
        style="display: flex; justify-content: space-between;"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            gap: 16px;
            align-items: center;
          "
        >
          <v-card
            elevation="1"
            style="
              cursor: pointer;
              padding: 5px 10px;
              width: 150px;
              border-radius: 10px;
            "
          >
            <date-range-picker
              ref="picker"
              opens="right"
              :locale-data="{ firstDay: 0, format: 'dd-mm-yyyy' }"
              :single-date-picker="true"
              :timePicker="false"
              :timePicker24Hour="false"
              :autoApply="true"
              :ranges="false"
              :max-date="Date.now()"
              control-container-class="input_date_picker"
              v-model="dateValue"
            >
              <template v-slot:header>
                <div class="usersReportCallendarSlot">
                  <p class="text-primary-color">
                    {{ dateNow.getFullYear() }}
                  </p>
                  <h3 class="text-primary-color font-italic ma-0 pa-0">
                    {{
                      dateNow.toLocaleDateString(`${language}`, {
                        weekday: "short",
                      }) | capitalizerFirstLetter
                    }},
                    {{
                      dateNow.toLocaleDateString(`${language}`, {
                        month: "long",
                      }) | capitalizerFirstLetter
                    }}
                    {{ dateNow.getDate() }}
                  </h3>
                </div>
              </template>
              <template v-slot:input="picker">
                <span class="holanda" v-if="picker.startDate === null">
                  Fecha
                </span>
                <span
                  style="color: black; text-align: left;"
                  v-if="picker.startDate != null"
                >
                  {{ new Date(picker.startDate).toLocaleDateString() }}
                </span>
              </template>
            </date-range-picker>
          </v-card>
          <v-btn
            class="button font-weight-bold black--text"
            small
            color="#00E676"
            :disabled="!dateValue ? true : false"
            @click="dateValue ? searchByDate() : false"
          >
            Buscar
          </v-btn>
        </div>
        <v-btn
          class="white--text button"
          :color="items.length ? '#00E676' : 'grey'"
          @click="items.length ? getCSV() : false"
        >
          <v-icon class="mr-2">
            mdi-tray-arrow-down
          </v-icon>
          Descargar report CSV
        </v-btn>
      </div>
    </div>
    <div class="ma-2 mt-10">
      <v-data-table
        :hide-default-header="true"
        :headers="headers"
        :items="items"
        class="elevation-1"
        :loader-height="20"
        :loading="tableLoading"
        loading-text="Loading data"
        @pagination="paginationData"
      >
        <template v-slot:header="{ props: { headers } }">
          <thead style="background-color: none;">
            <tr style="border: 1px solid tomato; background-color: none;">
              <th
                style="
                  color: #27e96a;
                  border: 1px solid #ebedf2;
                  text-align: center;
                  background-color: black;
                "
                v-for="(h, index) in headers"
                :key="index"
                :style="
                  index == 0
                    ? 'border-top-left-radius: 10px;'
                    : headers.length - 1 === index
                    ? 'border-top-right-radius: 10px;'
                    : ''
                "
              >
                {{ h.text }}
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item.lastConsult="{ item }">
          <p class="ma-0 text-center">
            {{ item.lastConsult | fmtDate }}
          </p>
        </template>
        <template v-slot:item.duration="{ item }">
          {{ item.duration | secondsToDuration }}
        </template>
        <template v-slot:item.callTime="{ item }">
          <p class="ma-0 text-center">
            {{ item.callTime | fmtDate }}
          </p>
        </template>
      </v-data-table>
    </div>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { getListenedCalls } from "@/entities/listened";
import { downloadFromBlob } from "../../lib/client.ts";
import {
  fmtDate,
  capitalizerFirstLetter,
  secondsToDuration,
} from "../../lib/filters.ts";

export default {
  name: "Recordings",
  components: {
    DateRangePicker,
  },
  filters: {
    fmtDate,
    capitalizerFirstLetter,
    secondsToDuration,
  },
  data: () => ({
    dateValue: "",
    showError: false,
    textError: "",
    items: [],
    language: navigator.language,
    tableLoading: false,
    headers: [
      {
        text: "Fecha de consulta",
        align: "start",
        value: "lastConsult",
      },
      { text: "Usuario", align: "center", value: "user" },
      { text: "Número telefónico", align: "center", value: "phone" },
      { text: "Duración", align: "center", value: "duration" },
      { text: "ID de campaña", align: "center", value: "campaign" },
      { text: "Fecha de la llamada", align: "center", value: "callTime" },
    ],
  }),
  computed: {
    dateNow() {
      const date = new Date();
      return date;
    },
  },
  methods: {
    getData: function (info) {
      return getListenedCalls(info)
        .then((res) => {
          const newData = res.map((item) => {
            return {
              lastConsult: item.listenTime,
              user: item.user,
              phone: item.phone,
              duration: item.duration,
              campaign: `${item.campaign ? item.campaign : "-"}`,
              callTime: item.callTime,
            };
          });
          return newData;
        })
        .catch(() => {
          this.showError = true;
          this.textError = "Error. Revisa tu conección e intenta nuevamente.";
        })
        .finally(() => (this.tableLoading = false));
    },
    searchByDate: function () {
      this.tableLoading = true;
      const dateISO = new Date(
        this.dateValue.endDate.getFullYear(),
        this.dateValue.endDate.getMonth(),
        this.dateValue.endDate.getDate(),
        0,
        0,
        0
      ).toISOString();
      this.getData(dateISO).then((res) => (this.items = res));
    },
    getCSV: function () {
      const dateISO = new Date(
        this.dateValue.endDate.getFullYear(),
        this.dateValue.endDate.getMonth(),
        this.dateValue.endDate.getDate(),
        0,
        0,
        0
      ).toISOString();
      getListenedCalls(dateISO, "csv").then((res) => {
        downloadFromBlob(
          res,
          `listened_calls_${new Date(
            this.dateValue.endDate
          ).toLocaleDateString()}`
        );
      });
    },
    paginationData: function (data) {
      if (this.items.length > data.itemsPerPage) {
        const totalPages = Math.ceil(this.items.length / data.itemsPerPage);
        if (totalPages == data.page || totalPages - 1 == data.page) {
          this.getData(this.items[this.items.length - 1].callTime).then(
            (res) => {
              this.items = this.items.concat(res);
            }
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.usersReportCallendarSlot {
  display: grid;
  height: 80px;
  background-color: black;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 5px;
}

.input_date_picker {
  border: none;
}
.theme--light.v-data-table {
  background-color: #ffffff;
  border-radius: 10px;
}
</style>
